import CryptoJS from 'crypto-js';

function md5Fn(message) {
  var hash = CryptoJS.MD5(message);
  return hash.toString(CryptoJS.enc.Hex);  // 默认输出是32位小写
}

export default {
  md5Fn
}
